<template>

	<CountrySelect :countries="countries" :selectedCountryProp="selectedCountry" @country-selected="selectCountry"
		class="select-country" />

</template>



<script setup>

import { computed } from 'vue';
import { PayoutStore } from '@/store/PayoutStore';
import CountrySelect from '@/components/Common/Country-Select.vue';

const payoutStore = PayoutStore();
const countries = computed(() => payoutStore.PayoutOptionCountries);
const selectedCountry = computed(() => payoutStore.PayoutOptionCurrentCountry);

const selectCountry = (country) => {
	payoutStore.changeCountryForPayoutOptions(country);
}

</script>



<style lang="scss" scoped>

@media screen and (max-width: vars.get-map-value(vars.$breakpoints, 'mobile')) {

	.select-country {
		width: 100%;
	}
}
</style>
